<template>
    <div class="login">
        <div class="login-box">
            <div class="login-head"><img src="/assets/logo.png" alt="Raumkarte Schwalm Aue"/></div>
            <div class="login-form">
                <v-form v-model="formValid" ref="form" lazy-validation @keyup.native.enter="login">
                    <div class="formItem">
                        <label>E-Mail</label>
                        <v-text-field
                                class="sr-input"
                                v-model="username"
                                :rules="nameRules"
                                hide-details
                                solo
                                flat
                                autofocus
                                required
                        ></v-text-field>
                    </div>
                    <div class="formItem">
                        <label>Passwort</label>
                        <v-text-field
                                class="sr-input"
                                type="password"
                                v-model="password"
                                hide-details
                                solo
                                flat
                                :rules="[ v => !!v || 'Password is required' ]"
                                required
                        ></v-text-field>
                    </div>
                    <v-btn
                            class="sr-button"
                            type="submit"
                            @click.prevent="login"
                            text
                            :loading="loading"
                            :disabled="!formValid && loading"
                    >
                        Login
                    </v-btn>
                </v-form>
            </div>
        </div>
      <div id="disclaimer">
        <div class="inner">
          Diese besondere Datenausgabe enthält personenbezogene Daten und darf daher nur für den internen, dienstlichen Gebrauch verwendet werden.
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        formValid: true,
        loading: false,
        username: '',
        password: '',
        nameRules: [
          v => !!v || 'Name is required'
        ]
      }
    },
    methods: {
      async login () {
        if (!this.$refs.form.validate() || this.loading) {
          return
        }
        this.loading = true

        try {
          await this.$store.dispatch('auth/login', {
            username: this.username,
            password: this.password
          })
        } catch (error) {
          this.loading = false
        }
        this.loading = false
      }
    }
  }
</script>

<style scoped>

</style>
